import React from "react";
import "./layout.scss";
import { sidebarIconsConfig } from "../../config/SideBarConfig";
import { useLocation, useNavigate } from "react-router-dom";

const Sidebar = () => {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <div className="sidebar-container">
      <div className="sidebar-title">Libraries</div>
      <div className="sidebar-links-container">
        {sidebarIconsConfig?.map((each) => {
          const linkActive =
            each?.link && location?.pathname?.includes(each?.link);
          return (
            <div
              className={`sidebar-links-item ${linkActive ? "active" : ""}`}
              key={each?.link}
              onClick={() => each?.url && navigate(each?.url)}
            >
              <div className="sidebar-links-icon">
                {(linkActive ? each?.activeIcon : each?.icon) ?? <></>}
              </div>
              <div className="sidebar-links-text">{each?.linkName ?? ""}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Sidebar;
